import type { ServerResponse } from 'http';

/**
 * Issues an HTTP redirect from a Pages Router lifecycle method (e.g.
 * `getInitialProps`). Equivalent to Express's `res.redirect`, but written
 * against the Node.js `ServerResponse` since this app no longer runs on
 * Express. For `getServerSideProps` prefer returning `{ redirect }`.
 */
const sendRedirect = (res: ServerResponse, location: string, statusCode = 302) => {
  res.statusCode = statusCode;
  res.setHeader('Location', location);
  res.end();
};

export default sendRedirect;
